import { FileOpenRounded, PaymentRounded } from '@mui/icons-material'
import { AppealStatus, TServiceOffer } from 'feature/appeals/type'
import { useAppSelector } from 'store/hooks'
import { Button } from 'ui'

import { OfferPriceBlock } from '../OfferPriceBlock/OfferPriceBlock'

import style from './OfferPaymentApprovedInf.module.scss'
import { useOfferPriceBlock } from '../OfferPriceBlock/useOfferPriceBlock'

type TOfferPaymentApprovedInf = {
  offer: TServiceOffer
  isOfferActive: boolean
  recalculateHandler: () => void
  isPaymentBlockActive: boolean
  recalcInProgress: boolean
  appealStatus: AppealStatus | null
}

// блок с кнопкой оплаты и перерасчера КП в статусе Approved SENT
export const OfferPaymentApprovedInf = ({
  offer,
  isOfferActive,
  recalculateHandler,
  isPaymentBlockActive,
  recalcInProgress,
  appealStatus,
}: TOfferPaymentApprovedInf) => {
  const { clientType } = useAppSelector(state => state.auth.authInfo)
  const { offerUrl, price, acquiringUrl, acquiringSecondUrl } = offer
  const {
    stage,
    isPartialPayment,
    showPayButton,
    payUrl,
    isCheckButtonVisible,
  } = useOfferPriceBlock(offer, appealStatus)

  const isRecalcButtonVisible =
    !acquiringSecondUrl &&
    !isOfferActive &&
    (stage === 'FULL' || stage === 'AWAITING_FIRST_PAYMENT')

  const isPayBlockVisible =
    isPaymentBlockActive &&
    !recalcInProgress &&
    (isPartialPayment ? showPayButton : true)

  const checkUrl = offer.checks[offer.checks.length - 1]?.url

  return (
    <>
      {offerUrl && (
        <Button
          // @ts-ignore
          to={offerUrl}
          target='_blank'
          startIcon={<FileOpenRounded color='primary' />}
          variant='contained'
          color='secondary'
          className={style.openCheck}
          data-testid='offer-open-btn'
        >
          Открыть коммерческое предложение
        </Button>
      )}

      {price > 0 && (
        <OfferPriceBlock offer={offer} appealStatus={appealStatus} />
      )}

      {price === 0 && (
        <div className={style.price}>
          <span className='default-text'>
            Скоро здесь появится возможность выбрать и оплатить коммерческое
            предложение.
          </span>
        </div>
      )}

      {recalcInProgress && (
        <div className={style.price}>
          <span className='default-text'>
            Производится перерасчет данных. После актуализации данных Вы сможете
            произвести оплату коммерческого предложения
          </span>
        </div>
      )}

      <div className={style.buttonsWrapper}>
        {isPayBlockVisible && (
          <div className={style.buttonsWrapper__top}>
            <Button
              //@ts-ignore
              to={isPartialPayment ? payUrl : acquiringUrl}
              target='_blank'
              startIcon={<PaymentRounded color='secondary' />}
              variant='contained'
              color='primary'
              disabled={!isOfferActive && stage !== 'AWAITING_SECOND_PAYMENT'}
              className={style.openCheck}
              data-testid='offer-recalc-btn'
            >
              {clientType === 'company' ? 'Счет' : 'Оплатить'}
            </Button>

            {isRecalcButtonVisible && (
              <Button
                onClick={recalculateHandler}
                variant='contained'
                color='primary'
                className={style.openCheck}
              >
                Пересчитать
              </Button>
            )}
          </div>
        )}

        {isCheckButtonVisible && checkUrl && (
          <Button
            // @ts-ignore
            to={checkUrl}
            target='_blank'
            startIcon={<FileOpenRounded color='primary' />}
            variant='contained'
            color='secondary'
            className={style.payButton}
          >
            Чек оплаты
          </Button>
        )}
      </div>
    </>
  )
}
